import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { ACCOUNT_WAITS, type AccountWait } from "../../api/accountsApi";
import AuthCardPage from "./AuthCardPage";
import BackToSignInLink from "./BackToSignInLink";

/** What the sign-in that led here said the account waits for (F133); none when opened directly. */
function waitFromState(state: unknown): AccountWait | null {
  if (typeof state !== "object" || state === null || !("waitsFor" in state)) return null;
  const { waitsFor } = state;
  return ACCOUNT_WAITS.find((wait) => wait === waitsFor) ?? null;
}

/** No session or product access is granted while the account waits; the page says for what. */
export default function WaitingForApprovalPage() {
  const { t } = useTranslation();
  const wait = waitFromState(useLocation().state);
  return (
    <AuthCardPage title={t("waitingApproval.title")}>
      <p className="app-text-muted mb-4">{wait === null ? t("waitingApproval.message") : t(`waitingApproval.waitsFor.${wait}`)}</p>
      <BackToSignInLink />
    </AuthCardPage>
  );
}
